// extracted by mini-css-extract-plugin
export default {"link":"link_DoPfB","arrow":"arrow_Gip5l","linkfixed":"linkfixed_xTxXe","blue":"blue_x6qTz","wrapper":"wrapper_Oz7Ui"};